/**
 * Re-attach Zalando-style banner CSS after Shopify injects #shopify-pc__banner__styles
 * so Admin appearance colors do not win on specificity/order.
 */
(function () {
  var LINK_ID = 'darido-privacy-banner-override';
  var href = document.currentScript && document.currentScript.dataset.href;
  if (!href) return;

  function ensureStylesheet() {
    if (document.getElementById(LINK_ID)) return;
    var link = document.createElement('link');
    link.id = LINK_ID;
    link.rel = 'stylesheet';
    link.href = href;
    (document.getElementById('shopify-pc__banner__styles') || document.head).appendChild(link);
  }

  function onBannerMount() {
    if (!document.getElementById('shopify-pc__banner')) return;
    ensureStylesheet();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onBannerMount);
  } else {
    onBannerMount();
  }

  new MutationObserver(onBannerMount).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
